import React from 'react';
import classnames from 'classnames';

import style from './feature-cell.module.less';

/**
 * @param {object} props
 * @param {string} [props.className]
 * @param {React.ReactNode} [props.children]
 * @param {boolean} [props.hideRowDivider]
 * @param {boolean} [props.isLastRowInColumn]
 * @param {boolean} [props.isLastRowInSection]
 * @param {boolean} [props.isCurrentPlanColumn]
 * @param {boolean} [props.isSelectedPlanColumn]
 * @returns {React.JSX.Element}
 */
export const FeatureCell = ({
  className,
  children,
  hideRowDivider,
  isLastRowInColumn,
  isLastRowInSection,
  isCurrentPlanColumn,
  isSelectedPlanColumn,
}) => {
  return (
    <div
      className={classnames(
        style['feature-cell'],
        { [style['is-current-plan-column']]: isCurrentPlanColumn },
        {
          [style['is-selected-plan-column']]: !isCurrentPlanColumn && isSelectedPlanColumn,
        },
        { [style['hide-row-divider']]: hideRowDivider || isLastRowInSection },
        {
          [style['is-last-row-in-section']]: !isLastRowInColumn && isLastRowInSection,
        },
        { [style['is-last-row-in-column']]: isLastRowInColumn },
        className,
      )}
    >
      {children}
    </div>
  );
};
